import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, NODE_COLORS } from "../../services/api";
import GraphView from "../../components/GraphView";

export default function IGLGraph() {
  const [graph, setGraph] = useState(null);
  const [focus, setFocus] = useState("");
  const [params] = useSearchParams();

  useEffect(() => {
    const f = params.get("focus");
    if (f) { setFocus(f); api.iglGraph(f).then(setGraph); }
    else api.iglGraph().then(setGraph);
  }, [params]);

  const refocus = (id) => { setFocus(id); api.iglGraph(id).then(setGraph); };
  const reset = () => { setFocus(""); api.iglGraph().then(setGraph); };

  return (
    <div className="graph-page">
      <div className="graph-toolbar">
        <div className="graph-legend">
          {["station", "asset", "workorder", "incident", "complaint", "certificate", "center", "region"].map((t) => (
            <span key={t} className="gl-item"><i style={{ background: NODE_COLORS[t] }} />{t}</span>
          ))}
        </div>
        <div className="graph-tb-actions">
          {focus && <span className="focus-chip">Focused: {focus}</span>}
          {focus && <button className="btn-ghost sm" onClick={reset}>Show full graph</button>}
        </div>
      </div>
      <div className="graph-canvas-wrap">
        {graph ? <GraphView nodes={graph.nodes} edges={graph.edges} onNodeClick={refocus} />
          : <div className="loading-page">Building IGL relationship graph…</div>}
      </div>
      <div className="graph-hint">IGL enterprise map — stations hold assets, assets generate work orders, stations link to incidents, complaints and hydro-test certificates. Click any node to traverse its neighbourhood.</div>
    </div>
  );
}
